import React, { useCallback } from 'react';

import { ResourceType } from 'services/resources';
import useAdminResource from '../hooks/useAdminResource';

import AdminLayout from 'layouts/Admin.layout';
import FormModal from 'components/FormModal';
import Table from 'components/Table';
import Button from 'components/Button';
import Search from 'components/Search';

import LocationForm from '../components/forms/Location.form';
import { EditAction, DeleteAction } from '../components/TableActions';

const LocationsPage = () => {
  const locations = useAdminResource({
    resource: ResourceType.locations,
    resourceName: 'location',
    searchFields: [
      'location_id',
      'location_name',
      'lat',
      'lon',
      'timezone_offset',
    ],
  });

  const onAction = useCallback((actionType, item) => {
    switch (actionType) {
      case EditAction.actionType:
        locations.onEdit(item);
        break

      case DeleteAction.actionType:
        locations.onDelete(item.location_id);
        break;

      default: // make eslint happy :)
    }
  }, [locations]);

  return (
    <AdminLayout
      title="Locations"
      icon="map-pin"
      extra={[
        <Search
          placeholder={locations.strings.searchPlaceholder}
          value={locations.searchVal}
          onChange={value => locations.search(value)}
        />,
        <Button
          type="primary"
          icon="plus"
          onClick={() => {
            locations.onCreate({ is_active: 1 });
          }}
        >
          {locations.strings.addButton}
        </Button>
      ]}
      formWidth="560px"
    >
      <FormModal
        title={locations.strings.formTitle}
        form={locations.form}
        submitText={locations.strings.formSubmitButton}
        onClose={() => locations.form.reset()}
      >
        <LocationForm form={locations.form} />
      </FormModal>
      <Table
        loading={locations.isLoading}
        dataSource={locations.list}
        actions={[
          EditAction,
          DeleteAction,
        ]}
        actionsProps={{
          resource: 'location',
        }}
        onAction={onAction}
        rowKey="location_id"
      >
        <Table.Column title="ID" dataIndex="location_id" />
        <Table.Column title="Name" dataIndex="location_name" />
        <Table.Column title="Latitude" dataIndex="lat" />
        <Table.Column title="Longitude" dataIndex="lon" />
        <Table.Column title="Timezone" dataIndex="timezone_offset" />
        <Table.Column title="Notes" dataIndex="notes" />
      </Table>
    </AdminLayout>
  );
};

export default LocationsPage;
